/** Locale helpers shared by the i18n setup and useLocale. No i18next import, no side effects. */
import { LOCALES, type Locale } from './resources';

/** localStorage key holding the user's chosen locale. */
export const LOCALE_STORAGE_KEY = 'rockyLang';

/** BCP 47 tag written to <html lang> for each locale. */
const HTML_LANG: Record<Locale, string> = {
  zh: 'zh-CN',
  en: 'en',
};

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as string[]).includes(value);
}

export function htmlLangFor(locale: Locale): string {
  return HTML_LANG[locale];
}

/** Set <html lang> so screen readers, hyphenation and browser translation see the right language. */
export function applyHtmlLang(doc: Pick<Document, 'documentElement'>, locale: Locale): void {
  doc.documentElement.lang = htmlLangFor(locale);
}

/** Remember the chosen locale. Storage can throw (privacy mode); the choice then lasts for the session only. */
export function persistLocale(storage: Pick<Storage, 'setItem'> | undefined, locale: Locale): void {
  try {
    storage?.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Not persisted; the in-memory language still changes.
  }
}
